import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiRepository } from '../../../../shared/infrastructure/api.repository';
import { Dashboard } from '../../domain/entities/dashboard.entity';
import { DashboardFilter, DashboardRepositoryPort } from '../../domain/repositories/dashboard.repository.port';
import { DashboardApiResponse, DashboardMapper } from '../mappers/dashboard.mapper';

@Injectable({ providedIn: 'root' })
export class DashboardRepository extends ApiRepository implements DashboardRepositoryPort {
  private readonly baseUrl = '/dashboard';

  getDashboard(filter?: DashboardFilter): Observable<Dashboard> {
    return this.post<DashboardApiResponse, { filter?: DashboardFilter }>(
      this.baseUrl,
      { filter },
    ).pipe(
      map(response => DashboardMapper.toDomain(response)),
    );
  }

  refreshDashboard(filter?: DashboardFilter): Observable<Dashboard> {
    return this.post<DashboardApiResponse, { filter?: DashboardFilter }>(
      `${this.baseUrl}/reset`,
      { filter },
    ).pipe(
      map(response => DashboardMapper.toDomain(response)),
    );
  }
}
